import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

export const FormDialog = ({ open, maxWidth = "sm", title, description, disabled = false, children, onClose, onSubmit }) => {
  const handleSubmit = e => {
    e.preventDefault();
    onSubmit && onSubmit(e.target);
  }

  const handleClose = (e, reason) => {
    if (reason !== "backdropClick") {
      onClose && onClose(e, reason);
    }
  }

  return (
    <Dialog
      fullWidth={true}
      maxWidth={maxWidth}
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-paper": {
          maxHeight: "75vh",
        }
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {description}
        </DialogContentText>
        <Box
          noValidate
          component="form"
          onSubmit={handleSubmit}
          sx={{
            mt: 1,
            pointerEvents: disabled ? "none" : "auto",
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            justifyContent: "space-between",
            "& > *": {
              mb: "12px !important",
            }
          }}
        >
          {children}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>Cancelar</Button>
        {!disabled && <Button variant="contained" color="secondary" onClick={onSubmit}>Salvar</Button>}
      </DialogActions>
    </Dialog>
  );
}
